import Quill from 'quill'

Quill.register('modules/textblockExpander', function(quill, options) {
    quill.on('text-change', function(_, __, source) {
        if (source !== 'user') return;

        const range = quill.getSelection();
        if (!range) return;

        const textBefore = quill.getText(0, range.index);
        const match =/\$([\w-]*)$/.exec(textBefore);

        if (match) {
            const partial = match[1];
            const suggestions = options.getSuggestions(partial);
            if (suggestions.length > 0) {
                options.showOverlay(range.index, suggestions);
            } else {
                options.closeOverlay?.()
            }
        } else {
            options.closeOverlay?.();
        }
    });
});
